module.exports = __webpack_public_path__ + "static/all-in-one-en-287e43f4f7678b0ba22761297e76af65.png";